import { render, staticRenderFns } from "./SubtasksItemToggle.vue?vue&type=template&id=4ab58126&scoped=true&"
import script from "./SubtasksItemToggle.vue?vue&type=script&lang=js&"
export * from "./SubtasksItemToggle.vue?vue&type=script&lang=js&"
import style0 from "./SubtasksItemToggle.vue?vue&type=style&index=0&id=4ab58126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab58126",
  null
  
)

export default component.exports